<ng-container *transloco="let t;">
    <div class="content-area-wrapper template-view container-xxl p-0">
        <div class="content-right">
            <div class="todo-app-list">
                <div class="app-fixed-search">    
                    <div class="d-flex align-content-center justify-content-between w-100">
                        <div class="input-group input-group-merge">
                        <div class="input-group-prepend">
                            <span class="input-group-text"><i class="feather icon-search text-muted"></i></span>
                        </div>
                        <input
                            type="text"
                            class="form-control"
                            id="templates-search"
                            placeholder="{{ t('Search templates - (general) - Search templates') }}"
                            aria-label="Search..."
                            aria-describedby="templates-search"
                            (keydown.enter)="onSearch($event.target.value)"
                        />
                        </div>
                    </div>
                    <div class="listview-icons-container">
                        <div class="tempplate-header-menus d-flex align-items-center justify-content-end">
                            <a class="p-50 pe-75 me-25 d-flex align-content-center icon-hover justify-content-center border-end" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Fitlers - title (general) - Filters')" (click)="toggleTemplateFilters()">
                                <i class="me-0 font-medium-1 feather icon-filter align-middle" [ngClass]="{'activeIcons': toggleTemplteFilter}"></i>
                            </a>
                            <a class="p-50 hidden d-flex align-content-center icon-hover justify-content-center" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Template listing - Main sidebar (Menu text) - Explore templates')">
                                <i class="me-25 font-medium-1 feather icon-layers align-middle"></i>
                            </a>
                            <a class="p-50 d-flex pe-75 align-content-center icon-hover me-1 justify-content-center border-end" placement="auto" [autoClose]="true" triggers="hover" [ngbTooltip]="t('Template listing - Main sidebar (Menu text) - My templates')">
                                <i class="feather font-medium-1 icon-file-text activeIcons"></i>
                            </a>
                            <div ngbDropdown class="d-inline-block">
                                <button type="button" class="btn btn-success add-temp-btn" [disabled]="(canBuildTemplates$ | async) === false" rippleEffect id="template-type" (click)="addNewTemplate(templateType.EFORM)">
                                    {{ t("Signable eform listing - New Signable form (modal - title) - New Signable form") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="template-filters-wrapper card mb-0 px-2 pt-50 pb-50" [hidden]="!toggleTemplteFilter">
                    <!-- filter Component  -->
                    <app-filters template_type="eform"></app-filters>
                </div>
            </div>
    
            <div class="table-listing">
                <app-template-table
                    [templateListing]="templateListing"
                    [loading]="loading"
                    [pagination]="pagination"
                    [page]="page"
                    (pageChange)="getTemplates($event, search)"
                ></app-template-table>
            </div>
        </div>
    </div>
</ng-container>